import React from "react";
import { Download } from "lucide-react";
import { TspCard, TspBarChart } from "../../../components/primitives";
import { downloadYearWise } from "../dashboardDownloads";

// One bar per year (books distributed that year) — a single series needs no
// legend, so this stays one color rather than the per-year palette Book Wise
// uses for its grouped bars.
// `data` = [{ name: "2024", quantity }] from buildYearWiseDistribution — the
// years the server returned (the current year and the ones before it), nothing else.
const YEAR_SERIES = [{ key: "quantity", name: "Books Distributed", color: "#06b6d4" }];

export default function YearWiseBookDistributionChart({ data }) {
  const chartData = data || [];
  const hasBooks = chartData.some((row) => Number(row.quantity) > 0);

  return (
    <TspCard
      title="Year Wise Book Distribution"
      className="tsp-dashboard-chart-card"
      action={
        <button type="button" className="tsp-download-text-btn" onClick={() => downloadYearWise(chartData)} disabled={!hasBooks} title="Download Excel">
          <Download size={14} /> Download
        </button>
      }
    >
      {hasBooks ? <TspBarChart data={chartData} xKey="name" series={YEAR_SERIES} /> : <p className="tsp-muted-text tsp-dashboard-chart-empty">No books distributed yet.</p>}
    </TspCard>
  );
}
